import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchReportRole } from "services/reportRole";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const ReportRolesMultiSelectorDropDown = ({
    errors,
    control,
    setValue,
    getValues,
    watch,
    rowData,
    required,
}) => {
    const login = useSelector((state) => state?.jwtAuthreducer);
    const selectedRoleIds = watch("role_id") || [];

    const { data: roles, isLoading, error } = useQuery(
        ["roles"],
        () => fetchReportRole({ payload: { ...login } }),
        {
            staleTime: DROPDOWN_STALE_TIME,
        }
    );

    const options = useMemo(
        () =>
            roles?.data?.data?.map((role) => ({
                value: role.id,
                label: role.role_name,
            })) || [],
        [roles]
    );

    // useEffect(() => {
    //     if (rowData && options.length) {
    //         const selectedOptions = options.filter((option) =>
    //             rowData?.role_ids?.some((item) => item.id === option.value)
    //         );
    //         if (selectedOptions.length) {
    //             const ids = selectedOptions.map((opt) => opt.value);
    //             const names = selectedOptions.map((opt) => opt.label);
    //             setValue("role_id", ids);
    //             setValue("role_name", names);
    //         }
    //     }
    // }, [rowData, options, setValue]);

    useEffect(() => {
        if (rowData?.roles?.length && options.length) {
            const selectedOptions = options.filter((option) =>
                rowData.roles.some((item) => item.id === option.value)
            );

            if (selectedOptions.length) {
                const ids = selectedOptions.map((opt) => opt.value);
                const names = selectedOptions.map((opt) => opt.label);
                setValue("role_id", ids);
                setValue("role_name", names);
            }
        }
    }, [rowData, options, setValue]);

    if (isLoading) return <div>Loading...</div>;
    if (error) return <div>Error loading Role Data</div>;

    return (
        <Controller
            name="role_id"
            control={control}
            rules={{ required: required ? "At least one role is required" : false }}
            render={({ field }) => (
                <Select
                    {...field}
                    options={options}
                    isMulti
                    isClearable
                    value={options.filter((option) =>
                        selectedRoleIds.includes(option.value)
                    )}
                    placeholder="Select Roles"
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        control: (base) => ({
                            ...base,
                            minHeight: "45px",
                            maxHeight: "auto",
                            overflowY: "auto",
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            maxHeight: "45px",
                            overflowY: "auto",
                        }),
                        multiValue: (base) => ({
                            ...base,
                            maxWidth: "100%",
                        }),
                    }}
                    onChange={(selectedOptions) => {
                        const values = selectedOptions ? selectedOptions.map((opt) => opt.value) : [];
                        const labels = selectedOptions ? selectedOptions.map((opt) => opt.label) : [];
                        field.onChange(values);
                        setValue("role_id", values);
                        setValue("role_name", labels);
                    }}
                    className={`react-select-container ${errors.role_id ? "is-invalid" : ""}`}
                />
            )}
        />
    );
};

export default ReportRolesMultiSelectorDropDown;
